<div class="snotify-backdrop" *ngIf="backdrop >= 0" [style.opacity]="backdrop"></div>
<div *ngFor="let position of notifications | keys" class="snotify snotify-{{position}}">
  <ng-snotify-toast *ngFor="let notification of $any(notifications)[position] | slice:blockSize_a:blockSize_b" [toast]="notification" (stateChanged)="stateChanged($event)" >
  </ng-snotify-toast>
</div>
